import React, { Component } from "react";
import config from "../../../config";
import errorFunctions from "../../../store/errorFunctions";
import Activities from "../../Warranties/SingleWarranty/Activities/Activities";
export default class TicketDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sellers: [],
    };
  }

  componentDidMount() {
    this.retrieveTicket(this.props.computedMatch?.params.id);
  }

  retrieveTicket = async (id) => {
    this.setState({ loading: true });
    await this.props
      .protectedFetch(config.backendServer + "ticket/contractor/" + id + "/", "GET", { id }, errorFunctions.checkResponseThenJson)
      .then((res) => {
        this.setState({
          loading: false,
          details: res,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        console.log("fail");
      });
  };
  render() {
    return (
      <div className="page">
        <div>
          <h5>Ticket Detail</h5>
        </div>
        <div className="row">
          <div className="col-4">
            <div className="card">
              <div className="card-header">Ticket# : {this.state.details?.ticket_number}</div>

              <div className="card-body">
                <div className={"single-warranty-details-item"}>
                  <span className={"single-warranty-details-label"}>Owner: </span>
                  <span>{this.state.details?.user_device?.name}</span>
                </div>

                <div className={"single-warranty-details-item"}>
                  <span className={"single-warranty-details-label"}>Device Name: </span>
                  <span>{this.state.details?.user_device?.device.name}</span>
                </div>
                <div className={"single-warranty-details-item"}>
                  <span className={"single-warranty-details-label"}>Serial Number: </span>
                  <span>{this.state.details?.user_device?.serial_number}</span>
                </div>
                {this.state.details?.ticket_device_accessories?.length > 0 && (
                  <div className={"single-warranty-details-item"}>
                    <span className={"single-warranty-details-label"}>Items Received: </span>
                    <ul>
                      {this.state.details?.ticket_device_accessories?.map((item, i) => {
                        return <li key={i}>{`${item.accessory_name} (${item.quantity})`}</li>;
                      })}
                    </ul>
                  </div>
                )}
                <div className={"single-warranty-details-item"}>
                  <span className={"single-warranty-details-label"}>Seller Details: </span>
                  <span>{this.state.details?.user_device?.seller_details}</span>
                </div>
                <div className={"single-warranty-details-item"}>
                  <span className={"single-warranty-details-label"}>Store Location: </span>
                  <span>{this.state.details?.user_device?.store_location}</span>
                </div>
                <div className={"single-warranty-details-item"}>
                  <span className={"single-warranty-details-label"}>Has proof of purchase?: </span>
                  <span>{this.state.details?.user_device?.proof_of_purchase ? "Yes" : "No"}</span>
                </div>
                {/* If no proof of purchase, show purchase text */}
                {!this.state.details?.user_device?.proof_of_purchase && (
                  <div className={"single-warranty-details-item"} data-testid="purchase-info">
                    <span className={"single-warranty-details-label"}>Purchase info: </span>
                    <span>{this.state.details?.user_device?.proof_of_purchase_text || "Empty"}</span>
                  </div>
                )}
                {/* If proof of purchase, button to download */}
                {this.state.details?.user_device?.proof_of_purchase && (
                  <div data-testid="download-file">
                    <button
                      className="k-btn k-btn-outline-primary-full"
                      onClick={() => this.downloadFile(this.state.details?.ticket_number)}
                      style={{ margin: "10px 0" }}
                    >
                      Download Proof of Purchase
                    </button>
                    <div>
                      <small className="text-info">{this.state.downloadedText}</small>
                    </div>
                  </div>
                )}
                <div className={"single-warranty-details-item"}>
                  <div className={"single-warranty-details-label"}>Problem details:</div>
                  <ul>
                    {this.state.details?.reason?.map(function (item, i) {
                      return <li key={i}>{item}</li>;
                    })}
                  </ul>
                </div>
                <div className={"single-warranty-details-item"}>
                  <span className={"single-warranty-details-label"}>System Error: </span>
                  <span>{this.state.details?.system_error || ""}</span>
                </div>
                {this.state.details?.other_issue && (
                  <div className={"single-warranty-details-item"}>
                    <span className={"single-warranty-details-label"}>Other problem details: </span>
                    <span>{this.state.details?.other_issue}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-8">
            <div className="card">
              <div className="card-header">Activities</div>
              <div className="card-body">
                {" "}
                <Activities
                  userInfo={this.props.userInfo}
                  isHeadless={true}
                  details={this.state.details}
                  protectedFetch={this.props.protectedFetch}
                  retrieveWarranty={() => this.retrieveTicket(this.ticketId)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
